// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.medical-documents-actions-comment-text {\n  font-size: 13px;\n}\n.medical-documents-actions-comment-modal {\n  position: relative;\n}\n.medical-documents-actions-comment-modal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 13px;\n  right: 11px;\n}\n.medical-documents-buttons .c-button-label {\n  margin: 0 5px;\n}\n.c-table__cell__collapse__button {\n  padding: 0 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
